<script lang="ts">
export const elSortingHeaderDirections = ['down', 'up'] as const;
export type ElSortingHeaderDirection = (typeof elSortingHeaderDirections)[number];
</script>

<script setup lang="ts">
withDefaults(defineProps<{ direction: ElSortingHeaderDirection }>(), {
  direction: 'down',
});
</script>

<template>
  <div class="hover:bg-primary-light-hover flex h-4 w-4 items-center justify-center rounded-lg">
    <svg
      class="hover:fill-primary-hover active:fill-primary fill-disabled"
      :class="{ 'rotate-180': direction === 'up' }"
      width="13"
      height="12"
      viewBox="0 0 13 12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="solid/arrow-down">
        <path
          id="Vector"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.5 1.125C6.70711 1.125 6.875 1.29289 6.875 1.5L6.875 9.59467L9.98483 6.48484C10.1313 6.33839 10.3687 6.33839 10.5152 6.48484C10.6616 6.63128 10.6616 6.86872 10.5152 7.01516L6.76516 10.7652C6.61872 10.9116 6.38128 10.9116 6.23484 10.7652L2.48483 7.01517C2.33839 6.86872 2.33839 6.63128 2.48483 6.48484C2.63128 6.33839 2.86872 6.33839 3.01517 6.48484L6.125 9.59467L6.125 1.5C6.125 1.29289 6.29289 1.125 6.5 1.125Z"
        />
      </g>
    </svg>
  </div>
</template>
